import * as React from 'react';

import { CommunicationActionButton, CommunicationImage, CommunicationLayout } from '../../components/Communication';
import { LeaveContactsDialogContainer } from '../LeaveContactsDialogContainer';
import { useSimpleModal } from '../../utils/useSimpleModal';
import { ESentFrom } from '../../repositories/e2e-deal-form/entities/availability/LeaveContactsV2RequestSchema';
import { StageLayout } from '../../components/StageLayout';

export const SERVICE_AVAILABILITY_SUBSCRIBE = {
  communication: {
    title: 'Сервис временно недостуен',
    image: 'https://cdn.cian.site/frontend/e2e-form-assets/splash_screens/error.svg',
    message:
      'Мы делаем сервис лучше и совсем скоро снова запустим его. Оставьте ваш номер мобильного телефона, чтобы узнать о запуске.',
  },
  leaveContacts: {
    title: 'Оставьте свои контакты',
    description: 'Мы сообщим, когда запустим сервис',
    activatorLabel: 'Сообщите о запуске сервиса',
    successMessage: 'Cвяжемся с вами, когда запустим сервис',
  },
};
export const ServiceAvailabilitySubscribeContainer: React.FC = () => {
  const { communication, leaveContacts } = SERVICE_AVAILABILITY_SUBSCRIBE;

  const [isLeaveContactsModalOpen, openLeaveContactsModal, closeLeaveContactsModal] = useSimpleModal();

  return (
    <StageLayout>
      <CommunicationLayout
        title={communication.title}
        message={communication.message}
        image={<CommunicationImage src={communication.image} alt={communication.title} />}
        action={
          <CommunicationActionButton onClick={openLeaveContactsModal}>
            {leaveContacts.activatorLabel}
          </CommunicationActionButton>
        }
      />
      <LeaveContactsDialogContainer
        isOpen={isLeaveContactsModalOpen}
        onClose={closeLeaveContactsModal}
        calledFrom={ESentFrom.ServiceNotWorking}
        title={leaveContacts.title}
        subtitle={leaveContacts.description}
        successMessage={leaveContacts.successMessage}
      />
    </StageLayout>
  );
};
